export const mergeObjects = (base, newValues) => {
    const merged = { ...base };

    for (const key in newValues) {
        if (newValues.hasOwnProperty(key)) {
            if (typeof newValues[key] === 'object' && !Array.isArray(newValues[key])) {
                if (typeof base[key] === 'object' && !Array.isArray(base[key])) {
                    merged[key] = mergeObjects(base[key], newValues[key]);
                } else {
                    merged[key] = { ...newValues[key] };
                }
            } else {
                merged[key] = newValues[key];
            }
        }
    }

    return merged;
};